export const ALL_ITEMS_FILTER = "all";

export interface BoardEmptyStateInput {
  filterQuery: string;
  isContextReady: boolean;
  isLoading: boolean;
  isValidating: boolean;
  error: boolean;
  itemCount: number;
}

/**
 * Whether to render the "board has no synced items" empty state.
 *
 * Must distinguish a genuinely-empty board (request succeeded, zero items) from a
 * failed/timed-out request (which also leaves itemCount at 0 because the data
 * fallback is an empty array). On error we must NOT show the empty state — the page
 * shows an error + Retry instead. Previously this check omitted `error`, so a 60s
 * timeout on the All-items request rendered the empty state and hid the retry.
 */
export function shouldShowBoardEmptyState(input: BoardEmptyStateInput): boolean {
  return (
    input.filterQuery === ALL_ITEMS_FILTER &&
    input.isContextReady &&
    !input.isLoading &&
    !input.isValidating &&
    !input.error &&
    input.itemCount === 0
  );
}
